/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestPaymasterConfigurableMisbehavior,
  TestPaymasterConfigurableMisbehaviorInterface,
} from "../TestPaymasterConfigurableMisbehavior";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualCharge",
        type: "uint256",
      },
    ],
    name: "SampleRecipientPostCall",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "SampleRecipientPreCall",
    type: "event",
  },
  {
    inputs: [],
    name: "CALLDATA_SIZE_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FORWARDER_HUB_OVERHEAD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAYMASTER_ACCEPTANCE_BUDGET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POST_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRE_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "expensiveGasLimits",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRelayHub",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "greedyAcceptanceBudget",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "outOfGasPre",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "transactionCalldataGasUsed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "relayWorker",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymaster",
            type: "address",
          },
          {
            internalType: "address",
            name: "forwarder",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "paymasterData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "clientId",
            type: "uint256",
          },
        ],
        internalType: "struct GsnTypes.RelayData",
        name: "relayData",
        type: "tuple",
      },
    ],
    name: "postRelayedCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "maxPossibleGas",
        type: "uint256",
      },
    ],
    name: "preRelayedCall",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "returnInvalidErrorCode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "revertPostRelayCall",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "revertPreRelayCall",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "revertPreRelayCallOnEvenBlocks",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRelayHub",
        name: "hub",
        type: "address",
      },
    ],
    name: "setRelayHub",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "setTrustedForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionPaymaster",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "destination",
        type: "address",
      },
    ],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawDuringPostRelayedCall",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawDuringPreRelayedCall",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
    ],
    name: "withdrawRelayHubDepositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setWithdrawDuringPostRelayedCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setWithdrawDuringPreRelayedCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setReturnInvalidErrorCode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setRevertPostRelayCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setRevertPreRelayCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setRevertPreRelayCallOnEvenBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setOutOfGasPre",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setGreedyAcceptanceBudget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
    ],
    name: "setExpensiveGasLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAllBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getGasAndDataLimits",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "acceptanceBudget",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "calldataSizeLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IPaymaster.GasAndDataLimits",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "acceptanceBudget",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "preRelayedCallGasLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "postRelayedCallGasLimit",
        type: "uint256",
      },
    ],
    name: "setGasLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "on",
        type: "bool",
      },
    ],
    name: "setTrustRecipientRevert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestPaymasterConfigurableMisbehaviorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestPaymasterConfigurableMisbehaviorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestPaymasterConfigurableMisbehavior__factory extends ContractFactory {
  constructor(...args: TestPaymasterConfigurableMisbehaviorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<TestPaymasterConfigurableMisbehavior> {
    return super.deploy(
      overrides || {}
    ) as Promise<TestPaymasterConfigurableMisbehavior>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TestPaymasterConfigurableMisbehavior {
    return super.attach(address) as TestPaymasterConfigurableMisbehavior;
  }
  override connect(
    signer: Signer
  ): TestPaymasterConfigurableMisbehavior__factory {
    return super.connect(
      signer
    ) as TestPaymasterConfigurableMisbehavior__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestPaymasterConfigurableMisbehaviorInterface {
    return new utils.Interface(
      _abi
    ) as TestPaymasterConfigurableMisbehaviorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestPaymasterConfigurableMisbehavior {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestPaymasterConfigurableMisbehavior;
  }
}
